export const columns = ['fixingDate', 'EKI', 'strike', 'step', 'amount', 'leverageAmount', 'deleteIcon'];
